import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { FiZapOff } from 'react-icons/fi';
import { Typography } from 'material-ui';
import { Doughnut, Chart } from 'react-chartjs-2';
import * as Decimal from 'decimal.js';
import { getColorsWithAlpha } from '../../constants/Colors';

export class DoughnutCardContent extends React.Component {
  componentWillMount = () => {
    Chart.pluginService.register({
      beforeDraw: function(chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.chart.ctx;

          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center;
          var fontStyle =
            centerConfig.fontStyle ||
            '"Inter-Regular", "Avenir", "Helvetica", "Arial", sans-serif';
          var txt = centerConfig.text;
          var color = centerConfig.color || '#000';
          var sidePadding = centerConfig.sidePadding || 20;
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2);
          //Start with a base font of 30px
          ctx.font = '20px ' + fontStyle;

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width;
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth;
          var newFontSize = Math.floor(20 * widthRatio);
          var elementHeight = chart.innerRadius * 2;

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight);

          //Set font settings to draw it correctly.
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = fontSizeToUse + 'px ' + fontStyle;
          ctx.fillStyle = color;

          //Draw text in center
          ctx.fillText(txt, centerX, centerY);
        }
      },
    });
  };

  render() {
    const {
      classes,
      chartName,
      t,
      loading,
      centralPercentage,
      percentageWithLabelArray,
    } = this.props;

    if (loading) {
      return <CircularProgress size={24} className={classes.buttonProgress} />;
    }

    if (
      !percentageWithLabelArray ||
      percentageWithLabelArray.length === 0 ||
      (!centralPercentage && centralPercentage !== 0)
    ) {
      return (
        <Typography variant="body2" style={{ margin: 10, color: '#CECECE' }}>
          <FiZapOff style={{ position: 'relative', top: 3, marginRight: 10 }} />
          {t('No data yet')}
        </Typography>
      );
    }

    let centralPercentageFormatted =
      new Decimal.Decimal(centralPercentage).toFixed(0) + '%';
    const data = {
      labels: percentageWithLabelArray.map(e => e.asset.displayedName),
      datasets: [
        {
          data: percentageWithLabelArray.map(e => e.percentage),
          backgroundColor: getColorsWithAlpha(0.9),
          hoverBackgroundColor: getColorsWithAlpha(1),
        },
      ],
    };

    return (
      <Doughnut
        key={`${chartName}-doughnut-card-content-doughnutchart`}
        ref={ref => {
          this.myDoughnutChart = ref;
        }}
        data={data}
        width={1200}
        height={400}
        options={{
          plugins: {
            outlabels: {
              display: false,
            },
          },
          legend: {
            display: false,
          },
          maintainAspectRatio: false,
          responsive: true,
          elements: {
            center: {
              text: centralPercentageFormatted,
              color: 'rgba(0, 0, 0, 0.54)', // Default is #000000
              sidePadding: 20, // Default is 20 (as a percentage)
            },
          },
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                return data['labels'][tooltipItem[0]['index']];
              },
              label: function(tooltipItem, data) {
                let chartData = data.datasets[0].data;

                let rawPercentage = new Decimal.Decimal(
                  chartData[tooltipItem.index]
                );

                let dataDisplayed = rawPercentage.toFixed(2) + '%';

                return dataDisplayed;
              },
            },
          },
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartCards/DoughnutCardContent.js